import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Group from "@midland-industries/Components/Group";
import BrowseMenu from "@midland-industries/Components/Header/BrowseMenu";
import Menu from "@midland-industries/Components/Header/Menu";
import IconCategory2 from "@midland-industries/Icons/IconCategory2";
import IconChevronDown from "@midland-industries/Icons/IconChevronDown";
import { colors } from "@midland-industries/Styles/colors";
import React, { useState } from "react";
import { css } from "styled-components";

const downloadLinks = [
    { title: "Catalogs", url: "/Downloads/Catalogs" },
    { title: "Knowledge Bank", url: "/Downloads/knowledge-bank" },
    { title: "Sell Sheets", url: "/Downloads/sell-sheets" },
    { title: "Spec Sheets", url: "/Downloads/spec-sheets" },
    { title: "Download Price Sheets", url: "/Downloads/DownloadPricing" },
];

const Downloads = (
    <Group align="center" gap={3} style={{ cursor: "default" }}>
        <Typography weight={700} size={16} color={colors.textAccent}>
            Downloads
        </Typography>
        <Icon src={IconChevronDown} color={colors.textAccent} />
    </Group>
);

const marketingLinks = [
    { title: "Bin Labels", url: "/Marketing/bin-labels" },
    { title: "Mobile App", url: "/Marketing/mobile-app" },
    { title: "Private Labeling", url: "/Marketing/private-labeling" },
    { title: "Midland OEM Solutions", url: "/Marketing/oem-solutions" },
];

const Marketing = (
    <Link href="/Marketing">
        <Group align="center" gap={3}>
            <Typography weight={700} size={16} color={colors.textAccent}>
                Marketing
            </Typography>
            <Icon src={IconChevronDown} color={colors.textAccent} />
        </Group>
    </Link>
);

const aboutLinks = [
    { title: "Blog", url: "/about-us/midland-monthly" },
    { title: "Careers", url: "/about-us/Careers" },
];

const About = (
    <Link href="/about-us">
        <Group align="center" gap={3}>
            <Typography weight={700} size={16} color={colors.textAccent}>
                About
            </Typography>
            <Icon src={IconChevronDown} color={colors.textAccent} />
        </Group>
    </Link>
);

const contactLinks = [
    { title: "Customer Application", url: "/Contact/customer-application" },
    { title: "Request a Quote", url: "/Contact/Request-a-Quote" },
    { title: "Subscribe", url: "/Contact/Subscribe" },
    { title: "Distributor Request", url: "/Contact/distributor-request" },
    { title: "Reseller Application", url: "/Contact/reseller-application" },
];

const Contact = (
    <Link href="/Contact">
        <Group align="center" gap={3}>
            <Typography weight={700} size={16} color={colors.textAccent}>
                Contact
            </Typography>
            <Icon src={IconChevronDown} color={colors.textAccent} />
        </Group>
    </Link>
);

const ShoppingAs = (
    <Link>
        <Group align="center" gap={3}>
            <Typography weight={700} size={16} color={colors.textAccent}>
                Shopping As
            </Typography>
            <Icon src={IconChevronDown} color={colors.textAccent} />
        </Group>
    </Link>
);

interface HeaderNavigationProps {
    isLoggedIn: boolean;
    isVisible: boolean;
    customerLabel: string;
    fulfillmentLabel: string;
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
    isLoggedIn,
    customerLabel,
    fulfillmentLabel,
    isVisible,
}) => {
    const [browseOpen, setBrowseOpen] = useState(false);
    const history = useHistory();

    return (
        <Group
            justify="space-between"
            style={{
                marginTop: 24,
            }}
        >
            {isVisible ? (
                <>
                    <Group gap={20}>
                        <div
                            style={{ cursor: "default" }}
                            onFocus={() => setBrowseOpen(true)}
                            onMouseEnter={() => setBrowseOpen(true)}
                            onMouseLeave={() => setBrowseOpen(false)}
                        >
                            <Group align="center" gap={3}>
                                <Icon src={IconCategory2} color={colors.midlandRed} />
                                <Typography weight={700} size={16} color={colors.midlandRed}>
                                    Browse
                                </Typography>
                                <Icon src={IconChevronDown} color={colors.midlandRed} />
                            </Group>
                            <BrowseMenu isOpen={browseOpen} onClose={() => setBrowseOpen(false)} />
                        </div>
                        <Menu menuItems={downloadLinks} menuTrigger={Downloads} />
                        <Menu menuItems={marketingLinks} menuTrigger={Marketing} />
                        <Menu menuItems={aboutLinks} menuTrigger={About} />
                        <Link href="/LocationFinder">
                            <Group align="center" gap={3}>
                                <Typography weight={700} size={16} color={colors.textAccent}>
                                    Locations
                                </Typography>
                            </Group>
                        </Link>
                    </Group>
                    <Group gap={20}>
                        <Menu
                            menuItems={contactLinks}
                            menuTrigger={Contact}
                            cssOverrides={{
                                menu: css`
                                    right: -15px;
                                `,
                            }}
                        />
                        {isLoggedIn ? (
                            <Menu
                                menuItems={[
                                    {
                                        title: `${customerLabel}`,
                                        clickableProps: { onClick: () => undefined },
                                    },
                                    {
                                        title: `${fulfillmentLabel}`,
                                        clickableProps: { onClick: () => undefined },
                                    },
                                ]}
                                menuTrigger={ShoppingAs}
                                cssOverrides={{
                                    menu: css`
                                        right: -15px;
                                    `,
                                }}
                            />
                        ) : (
                            <></>
                        )}
                    </Group>
                </>
            ) : (
                <></>
            )}
        </Group>
    );
};

export default HeaderNavigation;
